import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import sortByAttribute from '../common/helpers/sortByAttribute';
export default function () {
  extend('flarum/forum/components/SignUpModal', 'oninit', function () {
    var _this$fofTermsPolicie;
    this.fofTermsPolicies = sortByAttribute(app.store.all('fof-terms-policies'));
    (_this$fofTermsPolicie = this.fofTermsPolicies) == null || _this$fofTermsPolicie.forEach(policy => {
      this[policy.form_key()] = false;
    });
  });
  extend('flarum/forum/components/SignUpModal', 'fields', function (fields) {
    var _this$fofTermsPolicie2;
    const legalText = app.forum.attribute('fof-terms.signup-legal-text');
    if (legalText) {
      fields.add('fof-terms-legal-text', m("div", {
        className: "Form-group"
      }, m("div", {
        className: "FoF-Terms-SignUp-Legal Alert"
      }, legalText)));
    }
    (_this$fofTermsPolicie2 = this.fofTermsPolicies) == null || _this$fofTermsPolicie2.forEach(policy => {
      fields.add('fof-terms-policy-' + policy.id(), m("div", {
        className: "Form-group"
      }, m("div", {
        className: "FoF-Terms-Check FoF-Terms-Check--signup"
      }, m("label", {
        className: "checkbox"
      }, m("input", {
        type: "checkbox",
        checked: this[policy.form_key()],
        onchange: () => {
          this[policy.form_key()] = !this[policy.form_key()];
        },
        disabled: this.loading
      }), app.translator.trans('fof-terms.forum.signup.i-accept', {
        policy: policy.name(),
        a: policy.url() ? m("a", {
          href: policy.url(),
          target: "_blank"
        }) : m("span", null)
      })))));
    });
  });
  extend('flarum/forum/components/SignUpModal', 'submitData', function (data) {
    var _this$fofTermsPolicie3;
    (_this$fofTermsPolicie3 = this.fofTermsPolicies) == null || _this$fofTermsPolicie3.forEach(policy => {
      data[policy.form_key()] = this[policy.form_key()];
    });
  });
}